import LogbookAndContainerNotes from './LogbookAndContainerNotes'

export default LogbookAndContainerNotes
